import { Box, Stack, Tooltip, Typography, useTheme } from "@mui/material";
import type { GridRenderCellParams } from "@mui/x-data-grid/models";

import { getUnitUsageColor } from "~/utils/unitUsageHelpers";

const SnapshotRenderCell = (params: GridRenderCellParams<any, number>) => {
  const theme = useTheme();

  const usedPercentage = params.value ?? 0;
  const backgroundColor = getUnitUsageColor(usedPercentage, theme);
  const expectedPercentage = (params.row.expectedUnits / params.row.allocatedUnits) * 100;

  return (
    <Box sx={{ display: "flex", alignItems: "center", position: "relative", height: "100%" }}>
      <Tooltip
        title={
          <Stack columnGap={1} display="grid" gridTemplateColumns="auto auto">
            <Typography>Used:</Typography>
            <Typography>{usedPercentage?.toFixed(2)}%</Typography>
            <Typography>Expected:</Typography>
            <Typography>{expectedPercentage?.toFixed(2)}%</Typography>
            <Typography>Variance:</Typography>
            <Typography>{params.row.variancePercentage.toFixed(2)}%</Typography>
          </Stack>
        }
      >
        <Stack
          direction="column"
          sx={(theme) => ({
            width: "100%",
            height: "100%",
            borderRadius: theme.shape.borderRadius,
            border: `1px solid ${theme.palette.divider}`,
            justifyContent: "center",
          })}
        >
          <Box
            sx={{
              width: `${usedPercentage}%`,
              maxWidth: "100%",
              height: "100%",
              backgroundColor,
              borderRadius: (theme) => theme.shape.borderRadius,
            }}
          />
          <Box bgcolor="red" height="100%" left={`${expectedPercentage}%`} position="absolute" width="2px" />
          <Typography
            alignSelf="center"
            pl={1}
            position="absolute"
            sx={{
              color: "white",
              textShadow: "1px 1px 0 black, -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black",
            }}
          >
            {`${params.row.claimUnits} of ${params.row.allocatedUnits} ${params.row.unitLabel}${params.row.claimUnits !== 1 ? "s" : ""}`}
          </Typography>
        </Stack>
      </Tooltip>
    </Box>
  );
};

export default SnapshotRenderCell;
